import Referral from "./Referral";

class Experiment extends Referral {
    constructor(tag) {
        super(tag);
        this.value = localStorage.getItem(this.tag) || null;
    }

    getValue() {
        return this.value = localStorage.getItem(this.tag) || this.value;
    }

    setValue(value) {
        this.value = value;
        localStorage.setItem(this.tag, this.value);
    }
}
export default Experiment;
